"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionColumnHeader = exports.TableHeadCheckboxColumn = exports.TableHeadColumn = exports.TableHeadRow = exports.TableHead = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var globalCss_1 = require("@aon/aon-tws-common-ui/build/lib/globalCss");
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.TableHead = styled_components_1.default.thead.attrs({
    className: 'tws-table-head',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tth:first-child {\n\t\tmin-width: 30px;\n\t}\n"], ["\n\tth:first-child {\n\t\tmin-width: 30px;\n\t}\n"])));
exports.TableHead.displayName = 'TableHead';
exports.TableHeadRow = styled_components_1.default.tr.attrs({
    className: 'tws-table-head-row',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.TableHeadRow.displayName = 'TableHeadRow';
exports.TableHeadColumn = styled_components_1.default.th.attrs({})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tborder: ", ";\n\tmin-width: 150px;\n\tpadding-left: 0;\n\tpadding-top: 2px;\n\tpadding-bottom: 2px;\n\t", ";\n\tvertical-align: middle;\n\ttext-align: ", ";\n"], ["\n\tborder: ", ";\n\tmin-width: 150px;\n\tpadding-left: 0;\n\tpadding-top: 2px;\n\tpadding-bottom: 2px;\n\t", ";\n\tvertical-align: middle;\n\ttext-align: ", ";\n"])), globalVars_module_scss_1.default.border0, globalCss_1.cappedHeaderMedium, function (props) { return (props.columnName === 'actions' ? 'right' : 'left'); });
exports.TableHeadColumn.displayName = 'TableHeadColumn';
var TableHeadColumnContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\t.tws-i-icon {\n\t\tfont-size: 8px;\n\t\tmargin-left: 4px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\t.tws-i-icon {\n\t\tfont-size: 8px;\n\t\tmargin-left: 4px;\n\t}\n"])));
TableHeadColumnContainer.displayName = 'TableHeadColumnContainer';
exports.TableHeadCheckboxColumn = styled_components_1.default.th(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tmin-width: 50px;\n\twidth: 50px;\n\tbackground-color: '#ffffff';\n\tpadding: 0;\n"], ["\n\tmin-width: 50px;\n\twidth: 50px;\n\tbackground-color: '#ffffff';\n\tpadding: 0;\n"])));
var SortedIcon = (0, styled_components_1.default)(aon_tws_common_ui_1.Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tcolor: #444444 !important;\n"], ["\n\tcolor: #444444 !important;\n"])));
var UnsortedIcon = (0, styled_components_1.default)(aon_tws_common_ui_1.Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tcolor: #aaaaaa !important;\n"], ["\n\tcolor: #aaaaaa !important;\n"])));
var TooltipContentWrapper = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\ttext-transform: none;\n\tfont-weight: normal;\n"], ["\n\ttext-transform: none;\n\tfont-weight: normal;\n"])));
var DimensionColumnHeader = /** @class */ (function (_super) {
    __extends(DimensionColumnHeader, _super);
    function DimensionColumnHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSort = _this.handleSort.bind(_this);
        _this.tableHeadRef = React.createRef();
        return _this;
    }
    DimensionColumnHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, columns = _a.columns, sortAsc = _a.sortAsc, sortedBy = _a.sortedBy, theadClasses = _a.theadClasses;
        return (React.createElement(exports.TableHead, __assign({ ref: function (elem) { return (_this.tableHeadRef = elem); } }, this.props.attributes, { className: theadClasses }),
            React.createElement(exports.TableHeadRow, null,
                React.createElement(exports.TableHeadCheckboxColumn, null),
                columns.map(function (col, index) { return (React.createElement(exports.TableHeadColumn, { className: 'tws-table-head-column', style: { cursor: col.isSortable ? 'pointer' : 'default' }, onClick: function (e) { return col.isSortable && _this.handleSort(e, col, index); }, key: col.field, columnName: col.field },
                    React.createElement(TableHeadColumnContainer, null,
                        col.label,
                        col.isSortable &&
                            ((sortedBy === col.field && sortAsc && React.createElement(SortedIcon, { name: 'caret-up', "aria-hidden": 'true' })) ||
                                (sortedBy === col.field && !sortAsc && React.createElement(SortedIcon, { name: 'caret-down', "aria-hidden": 'true' })) ||
                                (sortedBy !== col.field && React.createElement(UnsortedIcon, { name: 'caret-down', "aria-hidden": 'true' }))),
                        col.tooltipContent !== undefined && (React.createElement(TooltipContentWrapper, null,
                            React.createElement(aon_tws_common_ui_1.Tooltip, { id: col.field + '-column-header-tooltip' }, col.tooltipContent)))))); }))));
    };
    DimensionColumnHeader.prototype.handleSort = function (e, column, columnIndex) {
        // handles sort by calling the call back from props
        if (this.props.handleSort) {
            this.props.handleSort(column.field, column.sortAscByDefault || false);
        }
        // This does not appear to be working
        // Adds sorted class name to the sorted column tds
        // const sortedColumnIndex: number = columnIndex;
        // const thead = this.tableHeadRef;
        // const table = thead.parentNode && thead.parentNode.tagName.toLowerCase() === 'table' ? thead.parentNode : null ;
        // const tbody = table && table!.getElementsByTagName('tbody');
        // const trCollection = tbody && tbody[0]!.getElementsByTagName('tr');
        // for (const tableRow of trCollection) {
        // 	const tdCollection = tableRow!.getElementsByTagName('td');
        // 	for (const tableColumn of tdCollection) {
        // 		if (tableColumn) {
        // 		if (tableColumn.cellIndex === sortedColumnIndex) {
        // 			tableColumn.classList!.add('sorted');
        // 		} else {
        // 			tableColumn.classList!.remove('sorted');
        // 		}
        // 		}
        // 	  }
        //   }
        return true;
    };
    return DimensionColumnHeader;
}(React.Component));
exports.DimensionColumnHeader = DimensionColumnHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
